import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/PublicacionTemporal`

export function insertar(publicacion) {
  return http.post(API_ENDPOINT, publicacion)
}

export function actualizar(publicacion) {
  return http.put(API_ENDPOINT, publicacion)
}

export function publicar(publicacion) {
  return http.post(`${API_ENDPOINT}/Publicar`, publicacion)
}

export function buscarAdjuntos(idPublicacionTemporal) {
  return http.get(`${API_ENDPOINT}/BuscarAdjuntos/${idPublicacionTemporal}`)
}

export function BuscarImagenPorAdjunto(idUsuario, idPublicacionTemporal, idAdjunto) {
  return http.get(
    `${API_ENDPOINT}/BuscarImagenPorAdjunto/${idUsuario}/${idPublicacionTemporal}/${idAdjunto}`,
    { responseType: 'blob' }
  )
}

export function buscarMoneda() {
  return http.get(`${API_ENDPOINT}/BuscarMoneda`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la moneda.',
      tipoError: 'moneda'
    }
  })
}

export function buscarMedioPago() {
  return http.get(`${API_ENDPOINT}/BuscarMedioPago`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los medios de pago.',
      tipoError: 'medioPago'
    }
  })
}

export function buscarMedioEnvio() {
  return http.get(`${API_ENDPOINT}/BuscarMedioEnvio`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener los medios de envío.',
      tipoError: 'medioEnvio'
    }
  })
}

export function buscarGarantia() {
  return http.get(`${API_ENDPOINT}/BuscarGarantia`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las garantías.',
      tipoError: 'garantia'
    }
  })
}

export function buscarUnidad() {
  return http.get(`${API_ENDPOINT}/BuscarUnidad`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las unidades.',
      tipoError: 'unidad'
    }
  })
}

export function obtenerUltimaNoPublicada(idUsuario) {
  return http.get(`${API_ENDPOINT}/ObtenerUltimaNoPublicada/${idUsuario}`)
}

export function eliminarPublicacionTemporal(idPublicacionTemporal) {
  return http.delete(`${API_ENDPOINT}/EliminarPublicacionTemporal/${idPublicacionTemporal}`)
}
